import React from 'react';
import Modal from '../../../Components/Modal';
import Form, { Actions, Radio, Conditional, Address, RequiredValidator } from '../../../Components/Form';
import { useWorkViewContext } from '../Provider';
import { useCurrentLocation } from '../../../Services/helpers';
import { usePreference } from '../../../Data/Preference';

const Optimise = ({ isOpen, setIsOpen }) => {
    return <Modal title="Optimise route" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{isOpen, setIsOpen}} />}
    </Modal>
}

const Inner = ({setIsOpen}) => {
    const { handleOptimise } = useWorkViewContext();
    const currentLocation = useCurrentLocation();
    const [optimisePreferences, setOptimisePreferences] = usePreference('work:optimise', {
        startFrom: 'Business',
        startAddress: null,
    });

    const handleSubmit = async (data) => {
        const marshalled = {
            startFrom: data.startFrom,
            startAddress: data.startFrom === 'Address' ? data.startAddress : null,
            startLocation: data.startFrom === 'Location' ? currentLocation : null,
        };

        return handleOptimise(marshalled);
    };

    const handleFormChange = (data) => {
        setOptimisePreferences({
            startFrom: data.startFrom,
            startAddress: data.startFrom === 'Address' ? data.startAddress : null,
        });
    };

    return <Form
            data={optimisePreferences}
            onSubmit={handleSubmit}
            onChange={handleFormChange}
            afterSubmit={() => setIsOpen(false)}
            closeModalOnSubmit
        >
            <Radio
                label="Start route from"
                name="startFrom"
                options={[
                    { value: 'Business', label: 'My business address' },
                    { value: 'Location', label: 'My current location' },
                    { value: 'Address', label: 'Select an address' },
                ]}
            />

            <Conditional condition={(data) => data.startFrom === 'Address'}>
                <Address
                    label="Start address"
                    name="startAddress"
                    validators={[RequiredValidator]}
                />
            </Conditional>

            <Actions submit={{ label: 'Optimise' }} cancel />
        </Form>;
};

export default Optimise;
